import classNames from "classnames";
import { ChevronRightIcon } from "../../AscIcons";
import AscLink from "../../AscLink/AscLink";
import AscGenericCard from "../AscGenericCard/AscGenericCard";
import styles from "./AscLinksCard.module.scss";

export interface AscLinksCardProps {
  title: string;
  links: Record<"label" | "url", string>[];
  className?: string;
  loading?: boolean;
}

export default function AscLinksCard({
  title,
  links,
  className,
  loading = false,
}: AscLinksCardProps) {
  return (
    <AscGenericCard
      className={classNames(styles.ground, className)}
      titleClassName={styles.cardTitle}
      bodyClassName={styles.cardBody}
      contentClassName={styles.cardContent}
      title={title}
      coverImageUrl={null}
      loading={loading}
    >
      {links?.map((link, id) => (
        <AscLink
          className={styles.linkWrapper}
          key={id}
          href={link?.url}
          innerWrapperTag="button"
        >
          <div className={styles.linkItem}>
            <div className={styles.linkTitle}>{link?.label}</div>
            <ChevronRightIcon className={styles.chevronIcon} />
          </div>
        </AscLink>
      ))}
    </AscGenericCard>
  );
}
